import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: 'uuid'
})
export class UuidPipe implements PipeTransform {
	transform(value: any, separator: string = '_') {
        let components = value.split(separator);

        let uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

        if (uuidRegex.test(components[components.length - 1])) {
            components.pop();
        }

		return(components.join('_'));
	}
}